import { Box, Typography } from '@mui/material';
import { FaChevronRight } from "react-icons/fa";

function Breadcrumb({ title, subtitle }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        my: 2,
      }}
      className="text"
      fontWeight={700}
      fontSize={14}
    >
      {/* 1. Category / Parent Title */}
      <Typography
        className="text"
        sx={{
          fontSize: 14,
          fontWeight: 700,
          cursor: 'pointer',
        }}
      >
        {title}
      </Typography>

      {/* 2. Separator */}
      <Box
        className="text"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 12,
        }}
      >
        <FaChevronRight size={12} />
      </Box>

      {/* 3. Subtitle / Current Page */}
      <Typography
        className="text"
        sx={{
          fontSize: 14,
          fontWeight: 700,
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
}

export default Breadcrumb;